import React from "react"
import classes from "./index.module.scss";
import { ReactComponent as PlayFilled } from 'images/play-filled.svg';
import { language } from "utility/env";

const SolidCore = (props) => {
    const {
        heading,
        description,
        list_items,
        featured_image_url
    } = props.fields;

    const items = list_items.map((list_item) => {
        return (
            <div key={list_item.text} className={classes.scPlay}>
                <PlayFilled className={classes.scPlayFilled} />
                <div className={classes.scLabel}>
                    {list_item.text}
                </div>
            </div>
        );
    });

    return (
        <section className={classes.scSectionWrapper}>
            <div className={classes.scContainer}>
                <div className={classes.scLeft}>
                    <div className={classes.scCreateQuieterSpace}>
                        {heading}
                    </div>
                    <div className={classes.scOurSolidCoreDoors}>
                        {description}
                    </div>
                    <div>
                        {items}
                    </div>
                </div>
                <div className={classes.scRight}>
                    <img src={featured_image_url} alt="Solid Core Door" />
                </div>
            </div>
        </section>
    )

}

export default SolidCore
